import React from 'react';
import { Play, ExternalLink, Youtube, Facebook, Music } from 'lucide-react';
import { Button } from './ui/button';
import { socialLinks, artistData } from '../data/mock';

const WatchSection = () => {
  return (
    <section id="watch" className="py-24 bg-stone-950 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={artistData.images.performance}
          alt="Live Performance"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-950 via-stone-950/95 to-stone-950" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content Side */}
          <div>
            <div className="inline-flex items-center gap-2 bg-gold-500/10 border border-gold-500/20 rounded-full px-4 py-2 mb-6">
              <Play className="w-4 h-4 text-gold-400" />
              <span className="text-gold-300 text-sm font-medium">See Us Live</span>
            </div>

            <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
              Experience the <span className="text-gold-400">Music</span>
            </h2>

            <p className="text-lg text-stone-300 mb-8 leading-relaxed">
              Watch Alexander Richard perform live and get a taste of what CountrySoulN'Roll Entertainment brings to every show. From intimate acoustic sets to full band performances, every show is a celebration of classic country and rock.
            </p>

            {/* Social Links */}
            <div className="space-y-4">
              <a
                href={socialLinks.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 bg-stone-900/50 border border-stone-800 rounded-xl p-4 hover:border-red-500/50 hover:bg-red-500/10 transition-all duration-300 group"
              >
                <div className="w-12 h-12 rounded-xl bg-red-500/20 flex items-center justify-center group-hover:bg-red-500/30 transition-colors">
                  <Youtube className="w-6 h-6 text-red-500" />
                </div>
                <div className="flex-grow">
                  <p className="text-white font-semibold">YouTube</p>
                  <p className="text-stone-400 text-sm">Watch performance videos</p>
                </div>
                <ExternalLink className="w-5 h-5 text-stone-500 group-hover:text-red-500 transition-colors" />
              </a>

              <a
                href={socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 bg-stone-900/50 border border-stone-800 rounded-xl p-4 hover:border-blue-500/50 hover:bg-blue-500/10 transition-all duration-300 group"
              >
                <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center group-hover:bg-blue-500/30 transition-colors">
                  <Facebook className="w-6 h-6 text-blue-500" />
                </div>
                <div className="flex-grow">
                  <p className="text-white font-semibold">Facebook</p>
                  <p className="text-stone-400 text-sm">Follow for updates & events</p>
                </div>
                <ExternalLink className="w-5 h-5 text-stone-500 group-hover:text-blue-500 transition-colors" />
              </a>
            </div>
          </div>

          {/* Video Embed Side */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-video bg-stone-900">
              <iframe
                src="https://www.youtube.com/embed/2N-GcekuW6M"
                title="Alexander Richard Original Song"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              />
            </div>
            
            {/* Decorative Elements */}
            <div className="absolute -bottom-4 -right-4 w-32 h-32 border-2 border-gold-500/30 rounded-2xl -z-10" />
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-gold-500/10 rounded-2xl -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WatchSection;
